// removed by extract-text-webpack-plugin
module.exports = {"binary_logo":"_25f9iUUM_cj9XyZfy6Khzr","binary_breadcrums":"YnOnMyPHgYrxdTdzx6MqA","app":"_3sz-Jorbvi2LDO38TpQcMl","logo":"_3FPdgYCH7ng4B01tIp7UlO","binary_nav":"_2eyLCXxwodEkd3ONaUuzAo","appContent":"gsYlqHuubB3bKiaXdybMG","navbar-nav":"g2P5efLY-IeGePZ8DEfOn","dropdown":"_1y38NVCFHauRTs5uXFYEa6","navbar-default":"_34DB0575Q-BhMZQX9ALFgG","open":"_2Dul3KyNeaTSpl9od8OX6e"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/App/App.scss
// module id = 656
// module chunks = 0